/** @format */

import {
    BVSummarisedFeaturesResponse,
    FeedbackResponse,
    FilterType,
    InvalidResponse,
    ProductReviewDrawerType,
    ProductReviewFilterState,
    ProductReviewUiState,
    ProductReviewed,
    ProductReviewsProsConsState,
    Review,
    ReviewInfo,
    ReviewPhoto,
    ReviewSummary,
    Statistics,
    StatisticsResponse,
    TagDistributionValue
} from '../model';

import { AppProductReviewState } from '../+state';
import { RatingSummaryResponse } from '@shared/data-access/interfaces';

/*
 * Stanly  17yetarmblr20wmgsodr
 */
export const SAMPLE_PRODUCT_IDENTIFIER = '17YETARMBLR20WMGSODR';
export const SAMPLE_REVIEWS_SUMMARY_17YETARMBLR20WMGSODR: ReviewSummary = {
	reviewCount: 1,
	overallRatingRange: 5,
	averageRating: 3,
	recommendedCount: 1,
	notRecommendedCount: 0,
	totalRecommendationsCount: 1,
	recommendationPercentage: 100,
	ratingDistribution: [],
	secondaryRatings: [
		{
			averageRating: 4.551876379690949,
			valueRange: 5,
			minLabel: null,
			maxLabel: null,
			type: 'NORMAL',
			label: 'Quality'
		},
		{
			averageRating: 1.7903682719546743,
			type: 'SLIDER',
			valueRange: 3,
			minLabel: 'Runs Small',
			maxLabel: 'Runs Large',
			label: 'Fit/Size',
			valueLabel: ['Runs Small', 'Standard', 'Runs Large']
		},
		{
			averageRating: 4.320960698689956,
			valueRange: 5,
			minLabel: null,
			maxLabel: null,
			type: 'NORMAL',
			label: 'Value'
		}
	],
	tagDistribution: {
		[TagDistributionValue.PRO]: {
			id: 'pro',
			label: 'label pros',
			frequencies: [
				{
					name: '1',
					count: 1
				}
			]
		},
		[TagDistributionValue.CON]: {
			id: 'cons',
			label: 'label con',
			frequencies: [
				{
					name: '1',
					count: 1
				}
			]
		}
	},
	category: 'WomensFashionSneakers-129921',
	brand: 'Nike'
};

export const SAMPLE_REVIEWS_17YETARMBLR20WMGSODR: Review = {
	Id: '16970620',
	cID: '3eb2271d-845d-5bd8-908d-40ddf28c2584',
	SourceClient: 'conciergeapidocumentation',
	BadgesOrder: [
		"verifiedPurchaser",
		"incentivizedReview"
	],
	LastModeratedTime: '2017-01-05T19:36:11.000+00:00',
	LastModificationTime: '2017-01-05T19:36:11.000+00:00',
	ProductId: 'data-gen-moppq9ekthfzbc6qff3bqokie',
	UserLocation: 'Fayetteville, NC',
	AuthorId: 'data-gen-user-h52m1i3979qsxix62hdydqb9c',
	ContentLocale: 'en_US',
	IsFeatured: false,
	TotalInappropriateFeedbackCount: 1,
	TotalClientResponseCount: 1,
	TotalCommentCount: 1,
	Photos: [],
	Rating: 0,
	SecondaryRatingsOrder: [],
	IsRatingsOnly: false,
	IsRecommended: false,
	Helpfulness: 1,
	TotalFeedbackCount: 1,
	TotalNegativeFeedbackCount: 0,
	TotalPositiveFeedbackCount: 0,
	ModerationStatus: 'APPROVED',
	SubmissionTime: '2017-01-05T19:36:11.000+00:00',
	ReviewText:
		'Sed ac interdumlectus.Mauris mollis turpis sit amet neque porttitor ac venenatis mimollis.',
	Title: 'Pellentesque eget odioorci.',
	UserNickname: 'escalus39',
	Videos: [
		{
			VideoId: 'G4ehG34jEtA',
			VideoHost: 'www.youtube.com',
			VideoThumbnailUrl:
				'https://photos-uat-us.bazaarvoice.com/photo/2/cGhvdG86Y29uY2llcmdlYXBpZG9jdW1lbnRhdGlvbg/fede87ed-2ccf-5707-b031-13ce2a99e8b7',
			VideoIframeUrl: 'https://www.youtube.com/embed/G4ehG34jEtA',
			Caption:
				'Vestibulum luctus facilisis massa vestibulumscelerisque. Duis fermentum purus id leo consequat eget accumsan maurishendrerit. Mauris ut lacus non arcu faucibus scelerisque volutpat rhoncusdiam. Maecenas non soda',
			VideoUrl: 'https://www.youtube.com/watch?v=G4ehG34jEtA'
		},
		{
			VideoId: 'RGYwpjWxzV0',
			VideoHost: 'www.youtube.com',
			VideoThumbnailUrl: null,
			VideoIframeUrl: 'https://www.youtube.com/embed/RGYwpjWxzV0',
			Caption: 'Durable Great Bag Sturdy Easy to Assemble',
			VideoUrl: 'https://www.youtube.com/watch?v=RGYwpjWxzV0'
		}
	],
	SubmissionId: 'null',
	AdditionalFieldsOrder: [],
	TagDimensionsOrder: [],
	ClientResponses: [],
	Pros: 'null',
	RatingRange: 0,
	InappropriateFeedbackList: [],
	ContextDataValuesOrder: [],
	CampaignId: 'null',
	Cons: 'null',
	AdditionalFields: undefined,
	TagDimensions: {
		Con: {
			Label: 'Cons',
			Values: [
				'Example of wordy Con value',
				'Con 1',
				'Con 2',
				'yhjcyhj',
				'cyhjc',
				'gyjhcg',
				'yhcfgy',
				'jcfygjf',
				'xgjfcgy',
				'cjhgf',
				'yjhcg',
				'yjhcgyjhc',
				'gyjh'
			],
			Id: 'Con'
		},
		Pro: {
			Label: 'Pros',
			Values: [
				'Example of wordy Pro value',
				'Pro 2',
				'Pro 1',
				'hjghj',
				'cghjc',
				'ghjcghjc',
				'ghjc',
				'ghjcgh',
				'jcghj',
				'yjhcgyjh',
				'cgyjh'
			],
			Id: 'Pro'
		}
	},
	ProductRecommendationIds: [],
	CommentIds: [],
	IsSyndicated: false,
	SyndicationSource: {
		ClientId: null,
		LogoImageUrl:
			'https://photos-us.bazaarvoice.com/photo/2/cGhvdG86YXR0cmlidXRpb25sb2dvMg/6c1bb034-a753-49f3-a991-c9d2f054f303',
		ContentLink: '',
		Name: 'Nike'
	},
	ContextDataValues: undefined
};

export const SAMPLE_EMPTY_REVIEW_SUMMARY_17YETARMBLR20WMGSODR: ReviewSummary = {
	reviewCount: 0,
	overallRatingRange: 0,
	averageRating: 0,
	recommendedCount: 0,
	ratingDistribution: [],
	secondaryRatings: []
};

export const SAMPLE_STATISTICS_17YETARMBLR20WMGSODR: Statistics = {
	totalQuestionCount: 2000,
	totalAnswerCount: 3000
};

export const SAMPLE_EMPTY_STATISTICS_17YETARMBLR20WMGSODR: Statistics = {
	totalQuestionCount: 0,
	totalAnswerCount: 0
};

export const SAMPLE_PRODUCT_17YETARMBLR20WMGSODR: ProductReviewed = {
	productIdentifier: SAMPLE_PRODUCT_IDENTIFIER,
	name: 'YETI 20 oz. Rambler Tumbler with MagSlider Lid'
};

export const SAMPLE_BV_PIXEL = {
	brand: 'Stanley',
	category: 'WaterBottles-130004'
};

export const SAMPLE_BV_PIXEL_READY = {
	brand: 'Stanley',
	category: 'WaterBottles-130004',
	isBVPixelReady: true
};

export const SAMPLE_AI_SUMMARY = {
	summary: 'This product is overall great',
	status: 200,
	type: 'TEXT',
	title: 'REVIEW_SUMMARY',
	detail: 'PARAGRAPH_SUMMARY',
	disclaimer: 'This summary is generated by artificial intelligence based on customer reviews'
};

export const SAMPLE_BV_SUMMARISED_FEATURES_RESPONSE_17YETARMBLR20WMGSODR: BVSummarisedFeaturesResponse =
	{
		bestFeatures: [
			{
				featureId: '87173',
				feature: 'cold',
				percentPositive: 0,
				nativeFeature: 'cold',
				reviewsMentioned: {
					total: 0,
					positive: 0,
					negative: 0,
					incentivized: 0
				},
				averageRatingReviews: {
					positive: 0,
					negative: 0,
					incentivized: 0
				},
				_embedded: {
					quotes: [
						{
							quoteId:
								'7FN52QylOnp0+n1i7H7y+4i93Tt94J9ouWdZR5ldqcnOiDJB9NGPWcHwDcn1lkLHXllVhU8PG7w=',
							text: 'Great beverage holder that I mainly use for cold drinks and the beverage stays cold forever!',
							emotion: 'joy',
							reviewRating: 5,
							reviewId: 'd6141093-a8ed-5830-8100-2b9ff747e48e',
							reviewedAt: '2024-05-21',
							translatedText:
								'Great beverage holder that I mainly use for cold drinks and the beverage stays cold forever!',
							nativeLanguage: 'en-US',
							incentivised: false,
							reviewType: 'SYNDICATED'
						}
					]
				}
			}
		],
		worstFeatures: [
			{
				featureId: '111089',
				feature: 'defect',
				percentPositive: 0,
				nativeFeature: 'defect',
				reviewsMentioned: {
					total: 0,
					positive: 0,
					negative: 0,
					incentivized: 0
				},
				averageRatingReviews: {
					positive: 0,
					negative: 0,
					incentivized: 0
				},
				_embedded: {
					quotes: [
						{
							quoteId:
								'1Ee5ZIT3dPYKwr+T/tumD6QCPSzxY6V/53OW2skwD/K/UBCrwIBHSQoDnUY370kYrDb/3AoovhA=',
							text: 'Unfortunately my item was defective, I was looking forward to it and I had to return it',
							emotion: 'none',
							reviewRating: 1,
							reviewId: 'e1639046-82eb-5085-87e4-8a59f06a1e77',
							reviewedAt: '2021-10-27',
							translatedText:
								'Unfortunately my item was defective, I was looking forward to it and I had to return it',
							nativeLanguage: 'en-US',
							incentivised: false,
							reviewType: 'SYNDICATED'
						}
					]
				}
			}
		]
	};

export const MOCK_REVIEWS_STATE = {
	productIdentifier: SAMPLE_PRODUCT_IDENTIFIER,
	product: SAMPLE_PRODUCT_17YETARMBLR20WMGSODR,
	reviewSummary: SAMPLE_REVIEWS_SUMMARY_17YETARMBLR20WMGSODR,
	reviews: [SAMPLE_REVIEWS_17YETARMBLR20WMGSODR],
	statistics: SAMPLE_STATISTICS_17YETARMBLR20WMGSODR,
	currentReview: '',
	reviewsMultimedia: [SAMPLE_REVIEWS_17YETARMBLR20WMGSODR],
	BVPixel: SAMPLE_BV_PIXEL,
	aiReview: SAMPLE_AI_SUMMARY,
	prosCons: SAMPLE_BV_SUMMARISED_FEATURES_RESPONSE_17YETARMBLR20WMGSODR
};

export const MOCK_REVIEW_FILTER_STATE: ProductReviewFilterState = {
	filters: [{ id: '1', label: 'Test', type: FilterType.STANDARD, value: 'Test Value' }],
	search: 'Test',
	selectedTag: { id: '1', label: 'Test', selectedValue: { count: 20, value: 'Test Value' } },
	sort: { order: 'asc', type: 'foo' }
};

export const MOCK_REVIEW_UI_STATE: ProductReviewUiState = {
	productListDrawer: { drawerType: ProductReviewDrawerType.NONE, open: true },
	imageModal: false,
	slider: {
		media: {
			url: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0].VideoIframeUrl,
			id: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0].VideoId,
			reviewId: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Id,
			video: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0]
		},
		review: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR,
		position: {
			previous: null,
			current: 1,
			next: null
		}
	}
};

export const MOCK_REVIEW_PROS_CONS_STATE: ProductReviewsProsConsState = {
    pros: SAMPLE_BV_SUMMARISED_FEATURES_RESPONSE_17YETARMBLR20WMGSODR.bestFeatures,
    cons: SAMPLE_BV_SUMMARISED_FEATURES_RESPONSE_17YETARMBLR20WMGSODR.worstFeatures,
	selectedFeature: new InvalidResponse()
};

export const MOCK_PRODUCT_REVIEW_STATE: AppProductReviewState = {
	productReviewsState: MOCK_REVIEWS_STATE,
	productReviewsFilterState: MOCK_REVIEW_FILTER_STATE,
	productReviewsUiState: MOCK_REVIEW_UI_STATE,
    productReviewsProsConsState: MOCK_REVIEW_PROS_CONS_STATE
};

export const MOCK_REVIEWS_DISPATCH = {
	productIdentifier: SAMPLE_PRODUCT_IDENTIFIER,
	reviewSummary: SAMPLE_REVIEWS_SUMMARY_17YETARMBLR20WMGSODR,
	reviews: [SAMPLE_REVIEWS_17YETARMBLR20WMGSODR],
	product: SAMPLE_PRODUCT_17YETARMBLR20WMGSODR
};

export const MOCK_STATISTICS_DISPATCH = {
	statistics: SAMPLE_STATISTICS_17YETARMBLR20WMGSODR
};

export const REVIEW_PHOTOS_MOCK: ReviewPhoto[] = [
	{
		Sizes: {
			normal: {
				Id: '',
				Url: 'https://photos-uat-us.bazaarvoice.com/photo/2/cGhvdG86Y29uY2llcmdlYXBpZG9jdW1lbnRhdGlvbg/bd2dbaf1-9114-5405-b6d2-b32bd72cd155'
			},
			large: {
				Id: '',
				Url: 'https://photos-uat-us.bazaarvoice.com/photo/2/cGhvdG86Y29uY2llcmdlYXBpZG9jdW1lbnRhdGlvbg/bd2dbaf1-9114-5405-b6d2-b32bd72cd155'
			},
			thumbnail: {
				Id: '',
				Url: 'https://photos-uat-us.bazaarvoice.com/photo/2/cGhvdG86Y29uY2llcmdlYXBpZG9jdW1lbnRhdGlvbg/bd2dbaf1-9114-5405-b6d2-b32bd72cd155'
			}
		},
		Id: 'thumbnail',
		SizesOrder: [''],
		Caption: ''
	}
];

export const SAMPLE_REVIEWS_SUMMARY_EMPTY_SECONDARY_RATING_17YETARMBLR20WMGSODR: ReviewSummary = {
	reviewCount: 1,
	overallRatingRange: 5,
	averageRating: 3,
	recommendedCount: 1,
	notRecommendedCount: 0,
	totalRecommendationsCount: 1,
	recommendationPercentage: 100,
	ratingDistribution: [],
	secondaryRatings: []
};

export const SAMPLE_REVIEW_CONTEXT_DATA = {
	ContextDataValuesOrder: ['YourAge_2', 'Gender'],
	ContextDataValues: {
		YourAge_2: {
			Value: '2430',
			Id: 'YourAge_2',
			ValueLabel: '24 - 30',
			DimensionLabel: 'Your Age'
		},
		Gender: {
			Value: 'Female',
			Id: 'Gender',
			ValueLabel: 'Female',
			DimensionLabel: 'Gender'
		}
	}
};

export const SAMPLE_REVIEW_CONTEXT_DATA_MISSING_FIELDS = {
	ContextDataValuesOrder: ['YourAge_2', 'Gender'],
	ContextDataValues: {
		YourAge_2: {
			Value: '2430',
			Id: 'YourAge_2'
		},
		Gender: {
			Value: 'Female',
			Id: 'Gender',
			ValueLabel: 'Female',
			DimensionLabel: 'Gender'
		}
	}
};

export const SAMPLE_BADGES_ORDER_DATA = {
	BadgesOrder: ['incentivizedReview', 'verifiedPurchaser']
};

export const SAMPLE_SUBMITFEEDBACK_RESPONCE_17YETARMBLR20WMGSODR: FeedbackResponse = {
	HasErrors: false,
	Feedback: {
		Helpfulness: {
			Vote: 'POSITIVE',
			AuthorId: ''
		}
	},
	Locale: 'en_US',
	Errors: ['']
};

export const SAMPLE_REVIEWS_17YETARMBLR20WMGSODR_WITH_MEDIA: Review = {
	...SAMPLE_REVIEWS_17YETARMBLR20WMGSODR,
	Media: [
		{
			url: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0].VideoIframeUrl,
			id: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0].VideoId,
			reviewId: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Id,
			video: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[0]
		},
		{
			url: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[1].VideoIframeUrl,
			id: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[1].VideoId,
			reviewId: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Id,
			video: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR.Videos[1]
		}
	]
};

export const SAMPLE_REVIEWS_17YETARMBLR20WMGSODR_DRAWER: ReviewInfo = {
	reviews: [SAMPLE_REVIEWS_17YETARMBLR20WMGSODR_WITH_MEDIA],
	count: 1
};

export const SAMPLE_REVIEWS_17YETARMBLR20WMGSODR_REVIEW_STATISTICS = {
	AverageOverallRating: 3,
	NotRecommendedCount: 0,
	OverallRatingRange: 5,
	RatingDistribution: [],
	RecommendedCount: 1,
	SecondaryRatingsAverages: { },
	SecondaryRatingsAveragesOrder: [],
	TagDistribution: {},
	TotalReviewCount: 1
};

export const SAMPLE_REVIEWS_RESPONSE_17YETARMBLR20WMGSODR: RatingSummaryResponse = {
	Errors: [],
	HasErrors: false,
	Includes: { Products: {
			'17YETARMBLR20WMGSODR': {
				...SAMPLE_PRODUCT_17YETARMBLR20WMGSODR,
				ReviewStatistics: SAMPLE_REVIEWS_17YETARMBLR20WMGSODR_REVIEW_STATISTICS
			}
		}
	},
	Limit: 15,
	Locale: "en_US",
	Offset: 0,
	Results: [
		SAMPLE_REVIEWS_17YETARMBLR20WMGSODR
	]
};

export const SAMPLE_STATISTICS_RESPONSE_17YETARMBLR20WMGSODR: StatisticsResponse = {
	Errors: [],
	HasErrors: false,
	Includes: {},
	Limit: 15,
	Locale: "en_US",
	Offset: 0,
	Results: [{
		ProductStatistics: {
			ProductId: SAMPLE_PRODUCT_IDENTIFIER,
			NativeReviewStatistics: {},
			ReviewStatistics: {},
			QAStatistics: {
				TotalQuestionCount: 15,
				TotalAnswerCount: 13
			}
		}
	}],
	TotalResults: 1
};
